import { Title } from '@angular/platform-browser';
import { DetailBcLineinfos } from './../../bc/bc-components.service';
import { SocieteService } from './../../../shared/services/simple/societe.service';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { DetailBpinfos, DetailBpLineinfos } from './../bp-components.service';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BcLineService } from 'src/app/shared/services/bc/bc-line.service';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { StateService } from 'src/app/shared/services/state.service';
import { BcComponentsService, DetailBcinfos } from '../../bc/bc-components.service';
import { BpComponentsService } from '../bp-components.service';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { SpinnerModalComponent } from 'src/app/shared/components/modals/spinner/spinner-modal.component';

@Component({
    selector: 'app-facturation-bp',
    templateUrl: './facturation-bp.component.html',
    styleUrls: ['./facturation-bp.component.scss']
  })
  export class FacturationBpComponent implements OnInit {
    bpForm: UntypedFormGroup;
    bp: BpModel = new BpModel();
    user: string;
    observableBc = new BehaviorSubject<BcModel>(null);
    bcList: BcModel[];
    listOfBc: Observable<BcModel>;
    detailBpInfo: DetailBpinfos = new DetailBpinfos(); 
    DetailBpLineinfos: DetailBcLineinfos = new DetailBcLineinfos();
    bpSociety: SocieteModel = new SocieteModel();

    bpLineHTs = 0;
    bpLineTVAs = 0;
    bpLineTTCs = 0;

    constructor(private bpService: BpService,
                private router: Router,
                private route: ActivatedRoute,
                private dialog: MatDialog,
                private bpComponentsService: BpComponentsService,
                private stateService: StateService,
                private societeService: SocieteService,
                private toastrService: ToastrService,
                private title: Title) {
                  this.title.setTitle('SACHA - Facturation BP');

                  this.route.params.subscribe((params: any) => {
                    if (params.id === '0') {
                      this.bpService.bpSubscriber.subscribe((bp: BpModel) => {
                        if (bp !== null) {
                          this.bp = Object.assign({}, bp);
                        } else {
                          this.toastrService.error('Erreur durant la récupération du bon à payer.', 'Erreur');
                          this.router.navigate(['/']);
                        }
                      });
                    } else {
                      this.bpService.get(params.id).subscribe(bp => {
                        this.bp = bp;
                        this.getAndSetSociety(this.bp.idSociete).subscribe((society: SocieteModel) => {

                          this.setSociety(society);
                          this.stateService.changeSociety(this.bp.societe);
                          this.bpComponentsService.loadDetailBp().subscribe((infos: DetailBpinfos) => {
                            this.detailBpInfo = infos;
                            this.bpForm = this.bpComponentsService.getFacturateBpFormGroup(this.bp);
                          });
                          if (this.bpForm) {
                            this.bpLineTVAs = this.bpForm.get('tva').value;
                            this.bpLineTTCs = this.bpForm.get('ttc').value;
                            this.bpLineHTs = this.bpForm.get('ht').value;
                          }
                        }, (error) => {
                          toastrService.error('Le bon à payer n\'existe pas');
                          this.router.navigate(['/not-found']);
                        });
                    });
                    }
                  });
                }

    ngOnInit(): void {
    }

    close(): void {
      this.router.navigate(['/list-bp/']);
    }

    print(): void {
      window.open('/assets/pdfs/bcpdf.pdf');
    }

    facture(): void {
      const array = this.bpForm.get('bpLines') as UntypedFormArray;
      this.bp.bpLines = array.getRawValue();
      this.bp.refFourn = this.bpForm.get('refFourn').value;
      this.bp.codeFourn = this.bpForm.get('codeFourn').value;
      this.bp.libelleFourn = this.bpForm.get('libelleFourn').value;
      this.bp.numFacture = this.bpForm.get('numFacture').value;
      this.bp.dFacture = this.bpForm.get('dFacture').value;
      this.bp.dRegl = this.bpForm.get('dRegl').value;
      this.bp.codeCondRegl = this.bpForm.get('codeCondRegl').value;
      this.bp.libelleCondRegl = this.bpForm.get('libelleCondRegl').value;
      this.bp.codeModeRegl = this.bpForm.get('codeModeRegl').value;
      this.bp.libelleModeRegl = this.bpForm.get('libelleModeRegl').value;
      const dialogRef = this.dialog.open(SpinnerModalComponent);
      this.bpComponentsService.updateBp(this.bp).subscribe((res) => {
        if (res) {
          dialogRef.close();
          this.toastrService.success('Enregistrement reussi');
          this.router.navigate(['/list-bp/']);
        }
      }, (error) => dialogRef.close());
    }

    setSociety(society: SocieteModel): void {
      if (society) {
        this.bpSociety = Object.assign({}, society);
        this.bp.societe = this.bpSociety;
      }
    }

    getAndSetSociety(idSociety: number): Observable<SocieteModel> {
      return this.societeService.get(idSociety);
    }
  }
